(function employeeFileMassiveImportAddControllerDefinition() {
    'use strict';

    angular.module('EmployeeFileMassiveImport')
        .controller('EmployeeFileMassiveImportAddController', [
            '$filter', '$state', '$scope', 'errorsExtend', 'processService', 'authExtend', 'configViewService', 'fileService', 'storageService', 'fileDownloader', 'organizationalUnitService', '$q',
            function employeeFileMassiveImportAddController($filter, $state, $scope, errors, processService, auth, configViewService, fileService, storageService, fileDownloader, organizationalUnitService, $q) {

                $scope.addFile = function () {
                    $scope.aux.filesTemp.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            if (file.name.indexOf(".xlsx") > 0 || file.name.indexOf(".xls") > 0) {
                                var index = $scope.getIndexFile(file);
                                if (~index) {
                                    $scope.aux.files[index] = file;
                                } else {
                                    $scope.aux.files.push(file);
                                }
                            }
                        }
                    });

                    $scope.aux.filesTemp = [];
                };

                $scope.getIndexFile = function (fileNew) {

                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.cancel = function () {
                    $state.go('employee-file-massive-import-find');
                };

                $scope.removeFile = function (file) {
                    var index = $scope.getIndexFile(file);

                    if (~index) {
                        $scope.aux.files.splice(index, 1);
                    }
                };

                $scope.loadViewOptions = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if (!$scope.processTypes || $scope.processTypes.length == 0) {
                        configViewService.getById("CPPEmployeeFileMassiveImport").then(function (result) {
                            defered.resolve(result);
                        }, function (error) {
                            defered.reject(error);
                        });
                    }
                    else {
                        defered.resolve();
                    }

                    return promise;
                };

                $scope.loadMetadatas = function (item, providerConfig) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.createCriteria) {
                            var metadataCreateCriteria = {
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType.toLowerCase(),
                                metadataSystemName: metadata.systemName,
                                metadataIsRequired: metadata.createCriteria.isRequired,
                                metadataLabel: metadata.createCriteria.name,
                                metadataReadOnly: !metadata.createCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.createCriteria.order
                            };

                            if (metadata.systemName === '_wcertificate' && metadata.metadataOptionValues) {
                                metadataCreateCriteria.metadataOptions = $filter('filter')(metadata.metadataOptionValues, function (option) {
                                    switch (option.value) {
                                        case "E":
                                            return providerConfig['#EncodeEmployeeCertificateProvider'] === 'true';
                                        case "L":
                                            // TODO: Sacar despues del hotfix
                                            option.description = "Token";
                                            return providerConfig['#LakautEmployeeCertificateProvider'] === 'true';
                                        case "N":
                                            return providerConfig['#NacionEmployeeCertificateProvider'] === 'true';
                                        case "NS":
                                            return true;
                                    }

                                    return false;
                                }, true);

                                if (!auth.isInRole('CERTIFICATE START')) {
                                    metadataCreateCriteria.metadataValue = 'NS';
                                    $scope.ShowCertificateProvider = false;
                                } else if (metadataCreateCriteria.metadataOptions.length === 1) {
                                    metadataCreateCriteria.metadataValue = metadataCreateCriteria.metadataOptions[0].value;
                                    $scope.ShowCertificateProvider = false;
                                }
                            }

                            processType.metadatas.push(metadataCreateCriteria);
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.download = function () {
                    var ou = auth.getOrganizationId();

                    return fileService.downloadTemplate(ou).then(function (result) {
                        var success = fileDownloader.saveAs(result, 'altausuarios.xlsx');

                        if (!success) {
                            errors.showError('Api failed');
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                $scope.save = function () {
                    if (!$scope.employeeFileMassiveImportAdd.$valid) {
                        $scope.employeeFileMassiveImportAdd.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if ($scope.aux.files.length <= 0) {
                        errors.showError('VerifyFormFile');
                        return false;
                    }

                    var employeeFileMassiveImports = [];
                    var metadataValues = [];
                    
                    if ($scope.processType) {
                        $scope.processType.metadatas.forEach(function (meta) {
                            metadataValues.push({ systemName: meta.metadataSystemName, value: meta.metadataValue });
                        });
                    } else {
                        metadataValues.push({ systemName: '_wcertificate', value: 'NS' });
                    }


                    $scope.aux.files.forEach(function (file) {
                        var employeeFileMassiveImport = {};
                        employeeFileMassiveImport.name = file.name;
                        employeeFileMassiveImport.processTypeId = $scope.processType ? $scope.processType.id : 5;
                        employeeFileMassiveImport.organizationalUnitId = $scope.organizationalUnitId;
                        employeeFileMassiveImport.from = '"CPPEmployeeFileMassiveImport"';
                        employeeFileMassiveImport.metadataValues = metadataValues;
                        employeeFileMassiveImports.push(employeeFileMassiveImport);                        
                    });
                    
                    return processService.createBatch(employeeFileMassiveImports, $scope.aux.files).then(function () {
                        $state.go('employee-file-massive-import-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.load = function () {
                    $scope.organizationalUnitId = auth.getOrganizationId();
                    $scope.ShowCertificateProvider = false;
                    $scope.aux = {
                        files: [],
                        filesTemp: [],
                        processTypeId: ''
                    };

                    $q.all([$scope.loadViewOptions(), organizationalUnitService.getConfig($scope.organizationalUnitId, '#OuConfigCertificateProviders')]).then(function (result) {
                        if (result[0].processTypes && result[0].processTypes.length > 0) {
                            $scope.ShowCertificateProvider = true;
                            $scope.processTypes = [];
                            angular.forEach(result[0].processTypes, function (item) {
                                $scope.loadMetadatas(item, result[1]);
                            });

                            var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                            $scope.processType = found[0] || $scope.processTypes[0];
                        }
                    });
                };

                $scope.load();
            }
        ]);
})();
